import { render, staticRenderFns } from "./_TestPlyr.vue?vue&type=template&id=485fb0a6&"
import script from "./_TestPlyr.vue?vue&type=script&lang=js&"
export * from "./_TestPlyr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports